export const boxChipBlock = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'center',
    pl: 2,
    pb: 2,
    div: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
    }
}